import { ReactElement } from 'react';
import { ListFilter } from '../types';

export default function CheckboxFilterComponent({ listFilter, set, update }: { listFilter: ListFilter, set: (key: string, value: string[]) => void, update: (filterKey: string, updateValue: string, currentValues: string[]) => void }): ReactElement {
  return (
    <div className="position-relative">
      <div className="d-flex flex-column gap-2 position-absolute end-0">
        {listFilter.currentValues.length < listFilter.allValues.length &&
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={(): void => set(listFilter.key, listFilter.allValues.slice())}>alle ein</button>}
        {listFilter.currentValues.length > 0 &&
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={(): void => set(listFilter.key, [])}>alle aus</button>}
      </div>
      <div>
        {listFilter.allValues.map((value: string) => (
          <div key={value} className="form-check">
            <input className="form-check-input" type="checkbox" id={`${listFilter.key}-${value}`} checked={listFilter.currentValues.includes(value)} onChange={(): void => update(listFilter.key, value, listFilter.currentValues)} />
            <label className="form-check-label" htmlFor={`${listFilter.key}-${value}`}>{value}</label>
          </div>
        ))}
      </div>
    </div>
  );
}
